export enum RequestLang {
  ENGLISH = 'eng',
  SPANISH = 'spa',
  PORTUGUESE = 'por',
  GERMAN = 'deu',
  FRENCH = 'fra',
  ITALIAN = 'ita',
  KOREAN = 'kor',
  TURKISH = 'tur',
  ARABIC = 'arb',
  CHINESE = 'cmn',
  NON_ENGLISH = 'non-eng',
}

export type LoadingConfig = {
  condition: (requestLang: RequestLang) => boolean;
  timeFunction: (wordsCount: number) => number;
};

export type LoadingServiceParams = {
  requestText: string;
  requestLang: string;
};

export type AIDetectorVariation = 'control' | 'test';
